var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHidePassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3463 7.33471C21.7137 7.52596 21.8565 7.97886 21.6653 8.34627C21.2927 9.06199 20.7402 9.70356 20.064 10.2577C18.1797 11.8021 15.2387 12.75 12 12.75C8.76126 12.75 5.82033 11.8021 3.93598 10.2578C3.25976 9.70356 2.70731 9.06198 2.33474 8.34628C2.14348 7.97887 2.28628 7.52597 2.65369 7.33471C3.02111 7.14345 3.474 7.28625 3.66526 7.65366C3.92742 8.15726 4.33671 8.64678 4.88678 9.09759L4.88679 9.0976C6.44068 10.3711 9.01775 11.25 12 11.25C14.9823 11.25 17.5593 10.3711 19.1132 9.0976L19.1132 9.09759C19.6633 8.64677 20.0726 8.15725 20.3347 7.65367C20.526 7.28626 20.9789 7.14345 21.3463 7.33471Z",
    fill: "#1C1B1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2947 11.2756C14.6948 11.1684 15.1061 11.4058 15.2133 11.8059L16.2485 15.6696C16.3557 16.0697 16.1183 16.4809 15.7182 16.5881C15.3181 16.6954 14.9069 16.4579 14.7997 16.0578L13.7644 12.1941C13.6572 11.794 13.8946 11.3828 14.2947 11.2756Z",
    fill: "#1C1B1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1464 10.1465C18.4393 9.8536 18.9142 9.85359 19.2071 10.1465L22.0355 12.9749C22.3284 13.2678 22.3284 13.7426 22.0355 14.0355C21.7426 14.3284 21.2678 14.3284 20.9749 14.0356L18.1464 11.2072C17.8535 10.9143 17.8535 10.4394 18.1464 10.1465Z",
    fill: "#1C1B1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.85873 10.1465C6.15162 10.4394 6.15162 10.9143 5.85873 11.2071L3.03032 14.0356C2.73742 14.3284 2.26255 14.3284 1.96966 14.0355C1.67676 13.7427 1.67677 13.2678 1.96966 12.9749L4.79807 10.1465C5.09096 9.8536 5.56584 9.8536 5.85873 10.1465Z",
    fill: "#1C1B1E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.69322 11.2756C10.0933 11.3828 10.3308 11.794 10.2235 12.1941L9.18824 16.0578C9.08104 16.4579 8.66978 16.6954 8.26968 16.5881C7.86958 16.4809 7.63215 16.0697 7.73936 15.6696L8.77466 11.8059C8.88187 11.4058 9.29312 11.1684 9.69322 11.2756Z",
    fill: "#1C1B1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePassword);
export default __webpack_public_path__ + "static/media/hide-password.9968d85fa652634cd60ebb1bb35d2617.svg";
export { ForwardRef as ReactComponent };